import React, { Component } from "react";
import { Button, Row, Col, Select, Spin } from "antd";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import BarGroup from "../../../components/BarGroup/BarGroup";
// import Pie from "../../../components/Pie/Pie";
import "./bieu-do.scss";
// import ChartPrint from "../BangThongke/TablePrint";
import { connect } from "react-redux";
import { getDataQuan } from "../../../redux/actions/search.action";
import { AxiosGetSecretApi } from "../../../utils/fetchApi";
import PieChart from "./Chart/PieQuyHoachChung";
import StaticClass from "../../../utils/staticClass";
class BieuDo500 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedQuan: "TP",

      listQuan: this.props.listQuan,

      isShowChart: true,

      titleTable: "toàn Thành phố",
      dataTable: [],

      pieDataQuyHoach: [],

      pieDataDat: [],

      barData: [],
      barTitle: "Mật độ quy hoạch theo từng Quận/Huyện",
      barKey: [],
      isShowBarChart: false,
    };
    this.listDuAn = [];
  }

  componentDidMount() {
    if (this.props.listQuan.length === 0) this.props.getDataQuan();
    this.getTableDataThanhPho();
    this.getDataDat()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.listQuan !== this.props.listQuan) {
      this.setState({ listQuan: this.props.listQuan });
    }
  }

  onChangeQuan(value, option) {
    this.setState({
      selectedQuan: value,
      titleTable: option.name,
    });
    let id = value === "TP" ? undefined : value;
    this.getDataDat(id);
    if (id) {
      this.getTableDataQuan(id);
    } else {
      this.getTableDataThanhPho(id);
    }
  }

  async getTableDataThanhPho() {
    this.setState({ isShowBarChart: false });
    let url = "api/thongke/doanqh-chart";
    let res = await AxiosGetSecretApi(url);

    let dataTable = null;

    if (res && Array.isArray(res)) {
      // set table
      dataTable = res.map((o, i) => {
        return (
          <tr key={i}>
            <td>{i + 1}</td>
            <td style={{ textAlign: "left", paddingLeft: "10px" }}>
              {o.TENHUYEN}
            </td>
            <td>{o.TongSoDA}</td>
            <td>{StaticClass.formatPrice(o.DienTichTN)}</td>
            <td>{StaticClass.formatPrice(o.DienTichQH)}</td>
            <td>{StaticClass.formatPrice(o.MatDo)}</td>
            <td>{StaticClass.formatPrice(o.DDD)}</td>
            <td>{StaticClass.formatPrice(o.DNDD)}</td>
            <td>{StaticClass.formatPrice(o.DK)}</td>
          </tr>
        );
      });

      // pie data quy hoach
      let MatDoQuyHoach = 0;
      let MatDoChuaQuyHoach = 0;

      let DienTichQH = 0;
      let DienTichTN = 0;

      res.forEach((e) => {
        DienTichQH += e.DienTichQH;
        DienTichTN += e.DienTichTN;
      });

      MatDoQuyHoach = ((DienTichQH / DienTichTN) * 100).toFixed(3);
      MatDoChuaQuyHoach = (100 - MatDoQuyHoach).toFixed(3);
      let pieData = [
        {
          id: "Diện tích quy hoạch",
          label: "Diện tích quy hoạch",
          value: MatDoQuyHoach,
          DienTich: StaticClass.formatPrice((DienTichQH).toFixed(3)),
          color: "rgb(151, 227, 213)",
          CoBanHT: 0,
          chua: 0,
          cham: 0,
          dang: 0,
          tong: 0,
        },
        {
          id: "Diện tích chưa quy hoạch",
          label: "Diện tích chưa quy hoạch",
          value: MatDoChuaQuyHoach,
          DienTich: StaticClass.formatPrice((DienTichTN - DienTichQH).toFixed(3)),
          color: "rgb(244, 117, 96)",
          CoBanHT: 0,
          chua: 0,
          cham: 0,
          dang: 0,
          tong: 0,
        },
      ];
      // bar data

      let barData = {};
      let barKey = [];

      res.forEach((e) => {
        barKey.push(e.TENHUYEN);
        barData[`${e.TENHUYEN}`] = e.MatDo ? e.MatDo : 0;
        barData[`${e.TENHUYEN}_hover`] = e.TongSoDA ? e.TongSoDA : 0;
        barData[`${e.TENHUYEN}_CoBanHT`] = e.CoBanHoanThanh
          ? e.CoBanHoanThanh
          : 0;
        barData[`${e.TENHUYEN}_chua`] = e.ChuaTrienKhai ? e.ChuaTrienKhai : 0;
        barData[`${e.TENHUYEN}_cham`] = e.ChamTrienKhai ? e.ChamTrienKhai : 0;
        barData[`${e.TENHUYEN}_dang`] = e.DangTrienKhai ? e.DangTrienKhai : 0;
      });

      this.setState({
        dataTable,
        pieDataQuyHoach: pieData,
        barData: [barData],
        barTitle: "Mật độ quy hoạch theo từng Quận/Huyện",
        barKey: barKey,
      });
    } else {
      this.setState({
        dataTable: null,
        pieDataQuyHoach: [],
        barData: [],
        barTitle: "Mật độ quy hoạch theo từng Quận/Huyện",
        barKey: [],
      });
    }

    setTimeout(() => {
      this.setState({ isShowBarChart: true });
    }, 300);
  }

  async getTableDataQuan(id) {
    this.setState({ isShowBarChart: false });
    let url = `/api/thongke/doanqh-chart-phuong?IDHuyen=${id}`;
    let res = await AxiosGetSecretApi(url);
    let dataTable = null;

    if (res && Array.isArray(res)) {
      // set table
      dataTable = res.map((o, i) => {
        return (
          <tr key={i}>
            <td>{i + 1}</td>
            <td style={{ textAlign: "left", paddingLeft: "10px" }}>
              {o.TenPhuong}
            </td>
            <td>{o.TongSoDA}</td>
            <td>{StaticClass.formatPrice(o.DienTichTN)}</td>
            <td>{StaticClass.formatPrice(o.DienTichQH)}</td>
            <td>{StaticClass.formatPrice(o.MatDo)}</td>
            <td>{StaticClass.formatPrice(o.DDD)}</td>
            <td>{StaticClass.formatPrice(o.DNDD)}</td>
            <td>{StaticClass.formatPrice(o.DK)}</td>
            {/* <td>{o.name}</td> */}
          </tr>
        );
      });

      // pie data quy hoach
      let MatDoQuyHoach = 0;
      let MatDoChuaQuyHoach = 0;

      let DienTichQH = 0;
      let DienTichTN = 0;

      res.forEach((e) => {
        DienTichQH += e.DienTichQH;
        DienTichTN += e.DienTichTN;
      });

      MatDoQuyHoach =
        DienTichTN !== 0 ? ((DienTichQH / DienTichTN) * 100).toFixed(3) : 0;
      MatDoChuaQuyHoach = (100 - MatDoQuyHoach).toFixed(3);

      let pieData = [
        {
          id: "Diện tích quy hoạch",
          label: "Diện tích quy hoạch",
          value: MatDoQuyHoach,
          DienTich: StaticClass.formatPrice(Number.isInteger(DienTichQH) ? DienTichQH : DienTichQH.toFixed(3)),
          color: "rgb(151, 227, 213)",
          CoBanHT: 0,
          chua: 0,
          cham: 0,
          dang: 0,
          tong: 0,
        },
        {
          id: "Diện tích chưa quy hoạch",
          label: "Diện tích chưa quy hoạch",
          value: MatDoChuaQuyHoach,
          DienTich: StaticClass.formatPrice(Number.isInteger(DienTichTN - DienTichQH) ? (DienTichTN - DienTichQH) : (DienTichTN - DienTichQH).toFixed(3)),
          color: "rgb(244, 117, 96)",
          CoBanHT: 0,
          chua: 0,
          cham: 0,
          dang: 0,
          tong: 0,
        },
      ];
      // ----------=====----------

      // bar data
      let barData = {};
      let barKey = [];

      res.forEach((e) => {
        barKey.push(e.TenPhuong);
        barData[`${e.TenPhuong}`] = e.MatDo ? e.MatDo : 0;
        barData[`${e.TenPhuong}_hover`] = e.TongSoDA ? e.TongSoDA : 0;
        barData[`${e.TenPhuong}_CoBanHT`] = e.CoBanHoanThanh
          ? e.CoBanHoanThanh
          : 0;
        barData[`${e.TenPhuong}_chua`] = e.ChuaTrienKhai ? e.ChuaTrienKhai : 0;
        barData[`${e.TenPhuong}_cham`] = e.ChamTrienKhai ? e.ChamTrienKhai : 0;
        barData[`${e.TenPhuong}_dang`] = e.DangTrienKhai ? e.DangTrienKhai : 0;
      });

      this.setState({
        dataTable,
        pieDataQuyHoach: pieData,
        barData: [barData],
        barTitle: "Mật độ quy hoạch theo từng Phường/Xã",
        barKey: barKey,
      });
    } else {
      this.setState({
        dataTable: null,
        pieDataQuyHoach: [],
        barData: [],
        barTitle: "Mật độ quy hoạch theo từng Phường/Xã",
        barKey: [],
      });
    }
    setTimeout(() => {
      this.setState({ isShowBarChart: true });
    }, 300);
  }

  ChartPrint(type) {
    var windowContent = "<!DOCTYPE html>";
    windowContent += "<html>";
    windowContent += "<head>";
    windowContent += "<title> </title>";
    windowContent +=
      '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">';
    windowContent +=
      '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/antd/4.8.2/antd.min.css" integrity="sha512-CPolmBEaYWn1PClN5taQQ0ucEhAt+9j7+Tiog/SblkFjZ5k6M3TioqmlpcHKwUhIcsu1s7lgnX4Plsb6T8Kq5A==" crossorigin="anonymous" />';
    windowContent += `<link href="https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap&subset=vietnamese" rel="stylesheet">`;
    windowContent += `
    <style>
    .data-table {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      flex-direction: row;
    }

    #chart-table {
      border-collapse: collapse;
      width: 100%;
      // max-width: 1000px;
    }

    #chart-table td,
    #chart-table th {
        border: 1px solid #ddd;
        padding: 8px;
        font-size: 15px;

    }

    #chart-table tr:nth-child(even) {
        background-color: #f2f2f2;
    }

    #chart-table th {
        text-align: left;
        background-color: white;
        color: black;
    }

    #chart-table-2 {
      border-collapse: collapse;
      width: 100%;
      // max-width: 1000px;
  }

  #chart-table-2 td,
  #chart-table-2 th {
      border: 1px solid #ddd;
      padding: 8px;
      font-size: 15px;

  }

  #chart-table-2 tr:nth-child(even) {
      background-color: #f2f2f2;
  }

  #chart-table-2 th {
      text-align: left;
      background-color: white;
      color: black;
  }
  .fl-ct{
    background: red
  }
  </style>`;

    windowContent += "</head>";
    windowContent += "<body>";
    // bar-chart
    windowContent += `<div style="max-width: 210mm;">`;
    windowContent += `<div style="display: flex;justify-content: center;">`;
    windowContent += `<div style="width: 900px; margin-left: 50px; zoom: 0.8">`;
    windowContent += document.getElementById("bar-chart").innerHTML;
    windowContent += "</div>";
    windowContent += `</div>`;

    // bieu do
    windowContent += `<div style="display: flex;justify-content: center;">`;
    windowContent += `<div style="width: 900px; margin-left: 50px; zoom: 0.8">`;
    windowContent += document.getElementById("pie-chart").innerHTML;
    windowContent += "</div>";
    windowContent += `</div>`;

    windowContent += `<div style="display: flex;justify-content: center; zoom: 0.8">`;
    windowContent += `<div style="width: 900px; margin-left: 50px;">`;
    windowContent += document.getElementById("pie-chart-1").innerHTML;
    windowContent += "</div>";
    windowContent += `</div>`;
    windowContent += `</div>`;

    // bang
    windowContent += `<p style="page-break-after: always;"/>`;
    windowContent += `<div style="max-width: 210mm;">`;
    windowContent += `<div style="font-size: 16px;font-weight: bold;margin: 20px 0;">Bảng thống kê tổng hợp dự án quy hoạch chi tiết 1/500 ${this.state.titleTable}</div>`;
    windowContent += `<table id = "chart-table">`;
    windowContent += document.getElementById(`chart-table`).innerHTML;
    windowContent += "</table>";

    windowContent +=
      '<script src="https://cdnjs.cloudflare.com/ajax/libs/antd/4.8.2/antd.min.js" integrity="sha512-oHALdU5OO+FSQGCno//1Jqi69ERPucovxrFMGZxfNvQSL4P0WVf0i9yU81gBh2RSzIebQb9NrTloSizJ7Vtpew==" crossorigin="anonymous"></script>';
    windowContent += `</div>`;
    windowContent += "</body>";
    windowContent += "</html>";
    // var printWin = window.open();
    let printWin = window.open("", "", "width=1024,height=768");
    printWin.document.open();
    printWin.document.write(windowContent);

    printWin.document.close(); // necessary for IE >= 10
    printWin.moveTo(0, 0);
    printWin.resizeTo(window.screen.width, window.screen.height);
    printWin.focus(); // necessary for IE >= 10*/
    printWin.print();
    return true;
  }

  async getDataDat(id) {
    let url = "";
    if (id) {
      url = `/api/thongke/doanqh-dat-by-huyen?IDHuyen=${id}`;
    } else {
      url = `/api/thongke/doanqh-dat-by-tinh`;
    }

    let res = await AxiosGetSecretApi(url);
    if (res && Array.isArray(res)) {
      let pieDataDat = []
      res.forEach(e=>{
        let pie = {
          id: e.LoaiDat,
          label: e.LoaiDat,
          value: e.TyLe,
          color: e.LoaiDat === "Đất dân dụng" ? "#0DA2CC" : e.LoaiDat === "Đất ngoài dân dụng" ? "#EAAF84" : "#CACED8",
          children: e.Children ? JSON.parse(e.Children) : []
        }

        pieDataDat.push(pie)
      })
      this.setState({
        pieDataDat,
      });
    }
  }

  render() {
    return (
      <div className="bieu-do-500 bieu-do-tong-hop">
        <Row
          gutter={[20, 0]}
          style={{ marginLeft: "40px", marginRight: "20px", display: "flex" }}
        >
          <Col span={6} className="group">
            <div className="gr-body">
              <Select
                className="select"
                showSearch
                value={this.state.selectedQuan}
                onChange={(value, option) => this.onChangeQuan(value, option)}
              >
                <Select.Option value={"TP"} key={100} name={"toàn Thành phố"}>
                  TP.Đà Nẵng
                </Select.Option>
                {this.state.listQuan.map((e, i) => (
                  <Select.Option
                    value={e.MAHUYEN}
                    key={i}
                    name={
                      e.TENHUYEN === "Hoà Vang"
                        ? `huyện Hoà Vang`
                        : `quận ${e.TENHUYEN}`
                    }
                  >
                    {e.TENHUYEN}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>

        <Row gutter={[10, 0]} justify="center">
          <Col>
            {this.state.isShowBarChart ? (
              <div
                style={{
                  width: `${
                    this.state.barKey.length !== 0
                      ? this.state.barKey.length * 75
                      : 500
                  }px`,
                  minWidth: "500px",
                  height: 400,
                }}
                id="bar-chart"
              >
                <BarGroup
                  data={this.state.barData}
                  keys={this.state.barKey}
                  labelX={this.state.barTitle}
                  labelY="Mật độ quy hoạch (%)"
                  type="daqh"
                  legend={true}
                ></BarGroup>
              </div>
            ) : (
              <div
                style={{
                  width: `${
                    this.state.barKey.length !== 0
                      ? this.state.barKey.length * 75
                      : 500
                  }px`,
                  minWidth: "500px",
                  height: 400,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spin size="large"></Spin>
              </div>
            )}
          </Col>

          <Col>
            <div style={{ display: "flex" }}>
              <div id="pie-chart">
                <PieChart
                  width={600}
                  height={400}
                  data={this.state.pieDataQuyHoach}
                  title={`Biểu đồ mật độ quy hoạch ${this.state.titleTable}`}
                  type="QHCT_QuyHoach"
                ></PieChart>
              </div>

              <div id="pie-chart-1">
                <PieChart
                  width={600}
                  height={400}
                  data={this.state.pieDataDat}
                  title={`Biểu đồ mật độ các loại đất ${this.state.titleTable}`}
                  type="QHCT_Dat"
                ></PieChart>
              </div>
            </div>
          </Col>
        </Row>

        <div
          style={{
            paddingLeft: "10px",
            paddingRight: "10px",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <p style={{ fontWeight: "bold" }}>
            Bảng thống kê tổng hợp dự án quy hoạch chi tiết 1/500{" "}
            {this.state.titleTable}
          </p>
          <div>
            <table
              id="chart-table"
              style={{ width: "100%" }}
              className="thong-ke-500"
            >
              <tbody>
                <tr>
                  <th rowSpan="2">STT</th>
                  <th rowSpan="2">{this.state.selectedQuan === "TP" ? "Quận/Huyện" : "Phường/Xã"}</th>
                  <th rowSpan="2">Tổng số dự án</th>
                  <th rowSpan="2">Diện tích tự nhiên (ha)</th>
                  <th rowSpan="2">Diện tích quy hoạch (ha)</th>
                  <th rowSpan="2">Mật độ quy hoạch (%)</th>
                  <th colSpan="3">Loại đất (%)</th>
                </tr>
                <tr>
                  <th>Đất dân dụng</th>
                  <th>Đất ngoài dân dụng</th>
                  {/* <th>Chưa triển khai</th> */}
                  <th>Đất khác</th>
                </tr>
                {this.state.dataTable}
              </tbody>
            </table>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            marginTop: "15px",
            marginBottom: "10px",
            justifyContent: "center",
          }}
        >
          <ReactHtmlTableToExcel
            id="test-table-xls-button"
            className="ant-btn ant-btn-primary-cus"
            table="chart-table"
            filename={"Thống kê quy hoạch chi tiết 1/500"}
            sheet="tablexls"
            buttonText="Tải Excel"
          />
          <Button
            type="primary"
            className="button"
            style={{
              width: "117px",
              marginLeft: "10px",
              fontWeight: 700,
              height: "40px",
            }}
            onClick={() => this.ChartPrint("Thống kê quy hoạch chi tiết 1/500")}
          >
            In
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    listQuan: state.search.listQuan,
  };
};

const mapDispatchToProps = {
  getDataQuan: getDataQuan,
};

export default connect(mapStateToProps, mapDispatchToProps)(BieuDo500);
